import _ from 'lodash';
import { useEffect, useState } from 'react';
import { ColorPicker, ColorService } from 'react-color-palette';
import { FieldPathByValue, FieldValues, PathValue, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import Input, { InputProps } from './Input';
import 'react-color-palette/dist/css/rcp.css';

interface ColorPickerProps<TFieldValues extends FieldValues> extends InputProps<TFieldValues> {
  setValue: UseFormSetValue<TFieldValues>;
  watch: UseFormWatch<TFieldValues>;
  name: FieldPathByValue<TFieldValues, string>;
}

export const InputColor = <TFieldValues extends FieldValues>(
  props: ColorPickerProps<TFieldValues>
): JSX.Element => {
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const debouncedSetDisplayColor = _.debounce(setDisplayColorPicker, 150);
  const colorValue = props.watch(props.name);

  useEffect(() => {
    if (colorValue && !colorValue.startsWith('#')) {
      props.setValue(props.name, `#${colorValue}` as PathValue<TFieldValues, typeof props.name>);
    }
  }, [colorValue, props.name, props.setValue]);

  return (
    <div
      className="relative"
      onClick={() => debouncedSetDisplayColor(true)}
      onMouseLeave={() => debouncedSetDisplayColor(false)}
      role="none"
    >
      <Input {...props} />
      {displayColorPicker && (
        <div className="z-10 absolute py-5 px-10 w-3/4 top-0 right-10">
          <ColorPicker
            color={ColorService.convert('hex', colorValue ?? '')}
            onChange={val =>
              props.setValue(props.name, val.hex as PathValue<TFieldValues, typeof props.name>)
            }
            hideInput
          />
        </div>
      )}
    </div>
  );
};
